import React, { useState } from 'react';

const SimplePhoneInput = ({ value, onChange, placeholder = "Phone number", className = "" }) => {
  const [phoneNumber, setPhoneNumber] = useState(value || '');

  const handleChange = (e) => {
    const newValue = e.target.value;
    setPhoneNumber(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <input
      type="tel"
      value={phoneNumber}
      onChange={handleChange}
      placeholder={placeholder}
      className={`form-control ${className}`}
    />
  );
};

export default SimplePhoneInput; 